import { combineReducers } from '@reduxjs/toolkit';
import experiments from './experiment/slice';
import app from './app/slice';
import bookings from './bookings/slice';
import content from './content/slice';
import facilities from './facilities/slice';
import pageMeta from './pageMeta/slice';
import reviews from './reviews/slice';
import search from './search/slice';
import units from './units/slice';
import user from './user/slice';
import fileUpload from './fileUpload/slice';
import pages from './pages/slice';

export default combineReducers({
	app,
	bookings,
	content,
	facilities,
	pageMeta,
	pages,
	reviews,
	search,
	units,
	user,
	experiments,
	fileUpload
});
